
  const BASE_URL= "https://kollihills.store/shoppingbe";
  
    
  export const environment = {
    auth: BASE_URL,

    customer:{
        add:`${BASE_URL}/addcustomer`
    } ,

    cart:{
        add:`${BASE_URL}/addCartByCustomer`,
        get:`${BASE_URL}/getCartProducts`,
        updateSize:`${BASE_URL}/updateSize`,
    }

  }
  